import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-msg-box',
    template: ''
})
export class MsgBoxComponent {

    constructor(public dialog: MatDialog) { }

    public confirm(msg, title, succsessFn) {
        this.dialog.open(MsgBoxPopupComponent, {
            disableClose: true,
            data: {
                title: title,
                msg: msg,
                succsessFn: succsessFn,
                isAlert: false
            }
        });

    }

    public alert(msg, title?, okFn?) {
        this.dialog.open(MsgBoxPopupComponent, {
            disableClose: true,
            data: {
                title: title,
                msg: msg,
                succsessFn: okFn,
                isAlert: true
            }
        });
    }
}


@Component({
    selector: 'app-msg-box-popup',
    templateUrl: './msg.box.component.html'
})
export class MsgBoxPopupComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any
        , public dialogRef: MatDialogRef<MsgBoxPopupComponent>) { }

    public ok() {
        if (this.data.succsessFn) {
            this.data.succsessFn();
        }
        this.dialogRef.close();
    }

    public cancel() {
        this.dialogRef.close();
    }
}
